import ThumbFont from './thumbFont';

export default class ThumbText extends ThumbFont {
  constructor (parameters) {
    super();

    this.width = 122.5;
    this.id = null;

    this.setValues(parameters);
    this.uuid = Base64.encode(this.text).replace(/([^a-z0-9]+)/gi, '');
  }

  getTooltipHtml () {
    return this.tooltip ? 'data-container="body" data-popover="popover" data-placement="right" data-content="' + this.tooltip + '"' : '';
  }

  getItem () {
    const $container = this.getItemContainer();
    $container.find('a').append('<div title="' + this.text + '" class="text">' +
                                '<span>' +
                                  this.text.trimToLength(50) +
                                '</span>' +
                              '</div>');

    return $container;
  }
}
